import { render, staticRenderFns } from "./SalesTrendChart.vue?vue&type=template&id=32d6e8d8&"
import script from "./SalesTrendChart.vue?vue&type=script&lang=js&"
export * from "./SalesTrendChart.vue?vue&type=script&lang=js&"
import style0 from "./SalesTrendChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports